/**
 * basic externalization of frequently used store values in the search view
 */

// eslint-disable-next-line import/no-unresolved
import { computed } from '@vue/composition-api';

export default ({ app, store }) => {
  const state = {};

  state.fullscreenmap = computed(() => store.state.searchMapFullscreen);
  state.showModalStatus = computed(() => store.state.showModalStatus);
  state.isSeoPage = computed(() => store.state.isSeoPage);
  state.isSeaPage = computed(() => store.state.isSeaPage);
  state.isPlace = computed(() => store.getters.getLocationType === 3);
  state.country = computed(() => store.getters.getSearchLocationFilter('country') || '');
  state.region = computed(() => store.getters.getSearchLocationFilter('region') || '');
  state.totalObjects = computed(() => store.state.searchTotalObjects);
  state.totalObjectsCollapse = computed(() => store.state.searchTotalObjectsCollapse);
  state.ready = computed(() => store.state.searchSuccessfull && store.state.locationSuccessfull);
  state.offerID = computed(
    () => store.state.route.params.offer
          || store.state.route.query.offer
          || store.state.route.meta?.searchFilter?.offer,
  );
  state.seoContent = computed(() => {
    let locSeo;
    if (store.getters.getOfferData(state.offerID.value) !== false) {
      locSeo = store.getters.getOfferContent(state.offerID.value);
    } else {
      locSeo = store.getters.getLocationSeoContent;
    }
    return locSeo;
  });
  state.locationName = computed(() => {
    let locName = store.getters.getLocationName;
    if (locName === '') {
      locName = app.$t('common:locationNameEmpty');
    }
    return locName;
  });
  state.locationNamePreposition = computed(() => {
    let locNamePrepo = store.getters.getLocationNamePreposition || '';
    const locName = store.getters.getLocationName;
    if (locNamePrepo === '' && locName !== '') {
      locNamePrepo = app.$t('common:locationPrepositionEmpty');
    }
    return locNamePrepo;
  });
  state.locationNameWithPreposition = computed(() => store.getters.getLocationNameWithPreposition || '');
  state.locationTitle = computed(() => {
    let locTitle = '';
    if (state.offerID.value) {
      const offerContent = store.getters.getOfferContent(state.offerID.value);
      locTitle = offerContent.name;
    } else {
      locTitle = state.locationName.value;
    }

    // EDVUE-2717 always show destinationname, even on offer pages
    let locTitlePrepo = state.locationNameWithPreposition.value;
    if (locTitlePrepo === '') {
      locTitlePrepo = `${state.locationNamePreposition.value} ${state.locationName.value}`;
    }

    return { title: locTitle, titlePrepo: locTitlePrepo };
  });
  state.locationBreadcrumbs = computed(() => {
    let storeCrumbs;
    if (store.getters.getOfferData(state.offerID.value) !== false) {
      storeCrumbs = store.getters.getOfferBreadcrumbs(state.offerID.value);
    } else {
      storeCrumbs = store.getters.getLocationBreadcrumbs;
    }
    const crumbs = [];

    storeCrumbs.forEach((el) => {
      if (el.routeName) {
        crumbs.push({
          name: el.routeName,
          label: el.name,
          labelName: el.labelName || '',
        });
      } else {
        crumbs.push({
          path: el.url,
          label: el.name,
          labelName: el.labelName || '',
        });
      }
    });

    // fallback for searches without location
    if (!crumbs.length || !store.state.isSeoPage) {
      crumbs.push({
        path: store.state.route.path,
        label: app.$t('common:breadcrumbs.label.searchResults'),
      });
    }
    return crumbs;
  });

  return state;
};
